module.exports = __webpack_public_path__ + "background-tree-img.1b51186ab3c2e3c1dd1f.png";


//////////////////
// WEBPACK FOOTER
// D:/Projects/Embla/dev/shop.embla.no/client.shop.embla.no/src/assets/images/background-tree-img.png
// module id = ../../../../../src/assets/images/background-tree-img.png
// module chunks = styles